/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2018, Zumper
 * @description   marketing lead_type constants
 */

export const MESSAGE = 'message'
export const MULTI = 'multi'
